'use strict';

var AlgoliaSearchCore = require('../../AlgoliaSearchCore.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearchCore, 'Browser (lite)');



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch/src/browser/builds/algoliasearchLite.js
// module id = 967
// module chunks = 0 1 2 3 4 5 6 7 8